const templateableElementTypesArray = [
  "headline",
  "text",
  "form",
  "button",
  "survey",
  "row",
  "products",
  "product_hero",
  "conditional_row",
  "timer",
  "progress",
  "icon",
  "collapse",
  "tabs",
  "list",
  "carousel",
  "quiz",
  "reviews",
  "navigation",
];

export default templateableElementTypesArray;
